import React from 'react';
import './Button.css';

/**
 * LoadingButton Component
 * Button with nested circles loading animation
 * 
 * @param {string} variant - Button variant: 'primary'|'secondary'|'outline'|'danger'|'success' (default: 'primary')
 * @param {string} size - Button size: 'small'|'medium'|'large' (default: 'medium')
 * @param {boolean} disabled - Disabled state
 * @param {boolean} monochrome - Use monochrome/greyscale animation instead of colorful (default: false)
 * @param {string} className - Additional CSS classes
 */
const LoadingButton = ({ 
  variant = 'primary', 
  size = 'medium', 
  disabled = false,
  monochrome = false,
  className = '' 
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  const variantClass = `btn-${variant}`;
  const monochromeClass = monochrome ? 'btn-loading-monochrome' : '';
  
  return (
    <button
      className={`btn ${variantClass} btn-loading ${monochromeClass} ${sizeClass} ${className}`.trim()}
      disabled={true}
      aria-label="Loading"
    />
  );
};

export default LoadingButton;

